import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { FiX } from "react-icons/fi";
import { GetSearchParams } from "../../../../../../utils/functions/ResourceFunctions";
import {
  useCreateAppraisalObjectiveMutation,
  useGetAppraisalPeriodQuery,
  useGetHrDepartmentsQuery,
  useGetJobRoleQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  CustomSearchableSelect,
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../../Components/Forms/InputTemplate";
import { FaMinus, FaPlus } from "react-icons/fa";
export function ObjectivesModal1({
  isOpen,
  setIsOpen,
  isLoading,
  onValidate = () => {},
}) {
  const { data: departments } = useGetHrDepartmentsQuery();
  const { data: appraisalPeriod } = useGetAppraisalPeriodQuery({
    PageSize: 1000,
    ApprovalStatus: 0,
  });
  const [onCreate] = useCreateAppraisalObjectiveMutation();
  const defaultData = {
    title: GetSearchParams("title"),
    description: GetSearchParams("des"),
    appriasalObjectives: [{}],
  };

  const [appraisalObjectives, setApraisalObjectives] = useState([
    { id: Date.now() },
  ]);
  const [showIndex, setShowIndex] = useState(0);
  const [indexs, setIndexs] = useState(0);
  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });
  const {
    handleSubmit,
    formState: { isValid },
    watch, trigger,
    setValue, getValues,
  } = formMethods;
  const watchDepartments = watch(
    `appriasalObjectives[${indexs}].selectedDepartments`
  );

  // Transform departments data for multi-select
  const departmentOptions =
    departments?.responseObject?.pageItems?.map((dept) => ({
      value: dept.id,
      label: dept.name,
    })) || [];

  useEffect(() => {
    if (watchDepartments && Array.isArray(watchDepartments)) {
      const selectedDepartmentNames = watchDepartments
        .map((dept) => dept.label)
        .join(", ");
      const selectedDepartmentIds = watchDepartments.map((dept) => dept.value);
      setValue(
        `appriasalObjectives[${indexs}].departmentName`,
        selectedDepartmentNames
      );
      setValue(
        `appriasalObjectives[${indexs}].departmentIds`,
        selectedDepartmentIds
      );
    }
  }, [watchDepartments, setValue, indexs]);

  const submit = async (datas) => {
    // Add debugging
    let payloads = [];

    datas?.appriasalObjectives?.forEach((data) => {
      // Get the selected departments from the form data
      const selectedDepartments = data.selectedDepartments || [];
      const departmentIds = Array.isArray(selectedDepartments)
        ? selectedDepartments.map((dept) => dept.value)
        : [];
      const departmentNames = Array.isArray(selectedDepartments)
        ? selectedDepartments.map((dept) => dept.label)
        : [];

      const payload = {
        title: data.title,
        weight: parseInt(data.weight),
        departmentId: departmentIds, // Array of department IDs
        description: data.description,
        departmentName: departmentNames, // Array of department names
        objectiveType: parseInt(data.objectiveType),
        appraisalPeriodId: parseInt(data.appraisalPeriod),
        jobRoleId: parseInt(data?.jobRoleId),
      };
      payloads.push(payload);
    });
    try {
      const response = await onCreate({ objectives: payloads }).unwrap();
      if (response?.successful) {
        toast.success(response?.statusMessage);
        onValidate();
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.data?.statusMessage);
    }
  };

  const objectiveType = [
    {
      value: "Global",
      key: 0,
    },
    {
      value: "Operational",
      key: 1,
    },
    {
      value: "Committee",
      key: 2,
    },
    {
      value: "Personnel",
      key: 3,
    },
  ];
  const months = [
    { label: "Months" },
    { label: "January" },
    { label: "February" },
    { label: "March" },
    { label: "April" },
    { label: "May" },
    { label: "June" },
    { label: "July" },
    { label: "August" },
    { label: "September" },
    { label: "October" },
    { label: "November" },
    { label: "December" },
  ];

  const handleAddObjectives = () => {
    const newIndex = appraisalObjectives.length;
    setApraisalObjectives((prev) => [...prev, { id: Date.now() }]);
    setShowIndex((prev) => prev + 1);

    // Set default values for the new objective
    setValue(`appriasalObjectives.${newIndex}.title`, "");
    setValue(`appriasalObjectives.${newIndex}.objectiveType`, "");
    setValue(`appriasalObjectives.${newIndex}.appraisalPeriod`, "");
    setValue(`appriasalObjectives.${newIndex}.weight`, "");
    setValue(`appriasalObjectives.${newIndex}.selectedDepartments`, []);
    setValue(`appriasalObjectives.${newIndex}.departmentName`, "");
    setValue(`appriasalObjectives.${newIndex}.departmentIds`, []);
    setValue(`appriasalObjectives.${newIndex}.description`, '');
    trigger("appriasalObjectives");
  };

  const handleRemoveObjectives = (index) => {
    // 1. Get fresh values
    const fresh = getValues("appriasalObjectives") || [];

    // 2. Remove from array
    const updated = fresh.filter((_, i) => i !== index);

    // 3. Reset the ENTIRE appriasalObjectives array
    setValue("appriasalObjectives", updated);

  // 4. Sync UI state (your selector index)
  setApraisalObjectives(updated);
  setShowIndex(prev => (prev > 0 ? prev - 1 : 0));
  setIndexs(prev => Math.max(prev - 1, 0));
  trigger("appriasalObjectives");

};

  const { data: jobRole } = useGetJobRoleQuery({
    ApprovalStatus: 0,
    PageSize: 1000,
    PageNumber: 1,
  });
  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up </h4>
          <h1 className="text-[28px] font-[800]">Objectives</h1>
          <p>Set measurable objectives aligned with the employee’s job role.</p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        <div className="flex justify-between items-center mb-6 col-span-2">
          <p className="text-black">
            {showIndex + 1} of {appraisalObjectives?.length}
          </p>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              disabled={showIndex <= 0}
              className="bg-white rounded-md text-[var(--primary-color)] px-4 py-2"
              onClick={() => setShowIndex((prev) => Math.max(prev - 1, 0))}
            >
              Prev
            </button>

            <button
              disabled={showIndex >= appraisalObjectives?.length - 1}
              type="button"
              className="bg-[var(--primary-color)] text-white px-4 py-2 rounded-md"
              onClick={() => setShowIndex((prev) => prev + 1)}
            >
              Next
            </button>
          </div>{" "}
        </div>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              {appraisalObjectives?.map((dat, index) => (
                <section
                  onClick={() => setIndexs(index)}
                  key={index}
                  className={`${
                    showIndex === index ? "block" : "hidden pointer-events-none"
                  }`}
                >
                  {" "}
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-full">
                      <FormInput
                        title={"Objective Title"}
                        camelCase={`appriasalObjectives[${index}].title`}
                        placeholder={"select"}
                      />
                      <FormSelect
                        title={"Objective Type"}
                        camelCase={`appriasalObjectives[${index}].objectiveType`}
                        placeholder={"select"}
                        array={objectiveType.map((opt) => (
                          <option key={opt.value} value={opt.key}>
                            {opt.value}
                          </option>
                        ))}
                        defaultValue={"Select Object Type"}
                        defaultId={""}
                      />

                      <FormSelect
                        title={"Appraisal Period"}
                        camelCase={`appriasalObjectives[${index}].appraisalPeriod`}
                        placeholder={"select"}
                        array={
                          appraisalPeriod?.responseObject?.result
                            ?.map((opt) => {
                              if (!opt) return null;

                              const startMonthIndex = parseInt(
                                opt?.startMonth ?? 0
                              );
                              const endMonthIndex = parseInt(
                                opt?.endMonth ?? 0
                              );

                              // Ensure we stay within bounds of months array (0-11)
                              const safeStartMonth =
                                startMonthIndex >= 0 &&
                                startMonthIndex < months.length
                                  ? startMonthIndex
                                  : 0;
                              const safeEndMonth =
                                endMonthIndex >= 0 &&
                                endMonthIndex < months.length
                                  ? endMonthIndex
                                  : 0;

                              return (
                                <option
                                  key={opt.id || opt.value}
                                  value={opt.id}
                                >
                                  Year: {opt.year || "N/A"} Start month:{" "}
                                  {months[safeStartMonth]?.label || "N/A"} End
                                  Month: {months[safeEndMonth]?.label || "N/A"}
                                </option>
                              );
                            })
                            .filter(Boolean) || []
                        }
                        defaultValue={"Select Appraisal Period"}
                        defaultId={""}
                      />
                      <FormInput
                        title={"Weight"}
                        camelCase={`appriasalObjectives[${index}].weight`}
                        placeholder={"select"}
                      />

                    <CustomSearchableSelect
                      title={"Departments"}
                      camelCase={`appriasalObjectives[${index}].selectedDepartments`}
                      placeholder={"Select departments..."}
                      options={departmentOptions}
                      multiple={true}
                      isOptional={false}
                      moreRegister={{
                        onChange: (selectedOptions) => {
                          setValue(`appriasalObjectives[${index}].selectedDepartments`, selectedOptions || []);
                        },
                      }}
                    />
                     <FormSelect  isOptional={true}
                  title={"Job Role"}
                  camelCase={`appriasalObjectives[${index}].jobRoleId`}
                  placeholder={"select"}
                  array={jobRole?.responseObject?.pageItems?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt?.designationName}
                    </option>
                  ))}
                  defaultValue={"Select Job Role"}
                />
                    <div className="hidden">
                      <FormInput
                        title={`Department Name`}
                        camelCase={`appriasalObjectives[${index}].departmentName`}
                      />
                    </div>
                    <FormTextArea
                      className="h-[200px]"
                      title={"Objective Description"}
                      camelCase={`appriasalObjectives[${index}].description`}
                    />

                  </div>
                </div>
                  <div className="flex justify-end gap-4 mt-6">
                    {appraisalObjectives?.length > 1 && (
                      <button
                        onClick={() => handleRemoveObjectives(index)}
                        type="button"
                        className=" bg-red-50 text-red-900
                              px-5 py-2 rounded-sm flex items-center space-x-2"
                      >
                        <FaMinus />

                        <span>Remove Objectives</span>
                      </button>
                    )}
                    <button
                      onClick={handleAddObjectives}
                      type="button"
                      className="bg-[#18BB0C1A] text-[#18BB0C]
                             px-5 py-2 rounded-sm flex items-center space-x-2"
                    >
                      <FaPlus />

                      <span>Add Objectives</span>
                    </button>
                  </div>
                </section>
              ))}

              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Create
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
}
